import axios from "axios";
import mobiscope from "../../router/mobiscope.js";
import country_list from "../../locales/country_list.json";
// import { response } from "express";
var proxyurl = "https://corsanywhere.herokuapp.com/";
const host = window.location.host;
const parts = host.split(".");
const lang = window.navigator.userLanguage || window.navigator.language;
const brlanguage = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("language");



if(brlanguage =='ms'){
  brwlang ='malay';
}else if(brlanguage =='ar'){
  brwlang ='arabic';
}else if(brlanguage =='el'){
  brwlang ='greek';
}else if(brlanguage =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(brlanguage =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(brlanguage =='id'){
  brwlang ='indonesian';
}else if(brlanguage =='th'){
  brwlang ='thai';
}else if(brlanguage =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(brlanguage =='ro' || parts[0] =='ro'){
  brwlang ='romanian';
}else if(brlanguage =='en'){
  brwlang ='english';
}
let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = ''

if (type == true) {
    gcid = parts[1]
} else {
    gcid = ''
}

const state = {
     live: `http://cook.grabmobi.com`,
     local: `http://[::1]/PuretechGlobalContentPortal`,
     proxyurl: `https://corsanywhere.herokuapp.com/`,
    countryCode: parts[0],
    langButton: ``,
    language: brwlang,
    // language: sessionStorage.getItem("language"),
    src: "en",
    ar: "ar",
    gr: "el", //greek
    ms: "ms",
    translateCode: "",
    gcid_mobis: gcid,
    auth_mobis: '',
    secondLang: '',
    host_mobiscope: host,
    subscription_date_mobis: '',
    msisdn_mobis: '',
    
    country_name_mobis: '',
    gateway_mobis: '',
    is_unsub: '0'
};

const getters = {
    gcid_mobis: state => state.gcid_mobis,
    langButton: state => state.langButton,
    countryCode: state => state.countryCode,
    language: (state) => state.language,
    translateCode: (state) => state.translateCode,
    src: (state) => state.src,
    ar: (state) => state.ar,
    gr: (state) => state.gr,
    ms: (state) => state.ms,
    auth_mobis: state => state.auth_mobis,
    secondLang: state => state.secondLang,
    host_mobiscope: state => state.host_mobiscope,
    subscription_date_mobis: state => state.subscription_date_mobis,
    msisdn_mobis: state => state.msisdn_mobis,
   
    country_name_mobis: state => state.country_name_mobis,
    gateway_mobis: state => state.gateway_mobis,
    is_unsub_mobis: state => state.is_unsub,

};

const actions ={
  async fetchLang({commit}, lang){ 
      commit('setLanguage', lang);
  },
  async fetchTransButton({commit}, country) {
    let style_flag = "width: 21px; margin-right: 5px;";
    let style_button = "background: none; border: none;";
    let style_span = "font-weight: 600; font-size: 1.1rem; vertical-align: middle; color: white; text-transform: uppercase"

    for (let [key, value] of Object.entries(country_list)) {
      if(country == key){
        let button = `<button id="lang2" lang="${value.language}" class="lang2 " style="${style_button}">
          <img lang="${value.language}" class="flag" style="${style_flag}" src="${value.flag_rec}" />
          <span lang="${value.language}" style="${style_span}">${value.button_text}</span>
        </button>`

        commit("setButton", button);
      }
    }
  },
  async fetchTranslateCode({commit}, country){
    let transCode, secondLang = ""
    for (let [key, value] of Object.entries(country_list)) {
      if (key == country) {
        secondLang = value.language
        transCode = value.lang_code
      }
    }
    commit('setSecondLang', secondLang);
    commit('setTranslateCode', transCode);
  },
  async fetchToken_mobis({ commit, dispatch }, id) { 
    let auth = "";
    let check = "";

    let token = sessionStorage.getItem("tokenID"); 
    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }

    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkToken_mobiz", auth);
      // console.log(check)
      auth = auth.toLowerCase();
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (auth.match(letterNumber)) {
        check = true
      } else {
        check = false
      }
    } else {
      mobiscope.push({ name: "Login" }).catch(err => {});
    }
    
    if (check == true) { 
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };
      
      if (token != null) { 
         
        if(data.code == 'mobis80'){
          sessionStorage.setItem("tokenID", data.code);
          
          commit("setAuth", "guest");
        }else{
          sessionStorage.setItem("tokenID", data.code);
          
          commit("setAuth", "loggedin");
        }
        
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        if(data.code == 'mobis80'){ 
          sessionStorage.setItem("tokenID", data.code);
          commit("setAuth", "guest");
          mobiscope.push({ name: "Horoscope" }).catch(err => {});
        } else{ 
          let responses = await axios.post(
            `${proxyurl}`+`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`
            
          );
          // var response = JSON.parse(responses.data.contents);
          var response = responses.data;
         
          if (response.status == "inactive") {
            if(data.code != undefined){
              alert("Token is "+response.status)
            }
            mobiscope.push({ name: "Login" }).catch(err => {});
            // location.reload();
          } else if (response.status == "active") {
            localStorage.setItem("userTokenID_mobis",data.code );
            sessionStorage.setItem("tokenID", data.code);
            commit("setUserProfile", response);
            commit("setAuth", "loggedin");
            localStorage.setItem("mobis_msisdn",response.msisdn);
            localStorage.setItem("mobis_country_code",response.country_code);
            localStorage.setItem("mobis_gateway_code",response.gateway_code);
            mobiscope.push({ name: "Horoscope" }).catch(err => {});
          }
        }
      }
    } else {
      //if check is false
      mobiscope.push({ name: "Login" }).catch(err => {});
    }
  },
  async login_mobis({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
    
  },
  async guest_mobis({commit}){
    if(state.auth_mobis == 'guest'){
      commit("setAuth", "");
      sessionStorage.removeItem("tokenID");
      mobiscope.push({ name: "Login" }).catch(err => {});
    }
  },
  async logout_mobis({commit}, is_unsub){  
    if(is_unsub != '0'){ 
      
        let token = localStorage.getItem("userTokenID_mobis");
        let mobi_msisdn = localStorage.getItem("mobis_msisdn");
        let mobis_country_code = localStorage.getItem("mobis_country_code");
        let mobis_gateway_code = localStorage.getItem("mobis_gateway_code"); 
        axios.get(`${proxyurl}`+ `http://api.puretechglobal.net/gateway_request/${mobis_country_code}/${mobis_gateway_code}/unsub.php?code=${token}&msisdn=${mobi_msisdn}`
        )
        .then(function(resp) {
          location.reload();
          // alert(is_unsub);
        });
        
         sessionStorage.removeItem("tokenID");
         removeStorage();
        
    }else{
        removeStorage();
    }
    
    function removeStorage(){
        
        localStorage.removeItem("tokenID");
        localStorage.removeItem("userProfile_mobis");
        localStorage.removeItem("userTokenID_mobis");
        localStorage.removeItem("mobis_msisdn");
        localStorage.removeItem("mobis_country_code");
        localStorage.removeItem("mobis_gateway_code");
 
       


    } 
    
},
async getDomain_mobis({ commit }, host){
  let response = await axios.get(`${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`);
  let dom= response.data.data; 
  dom = dom.filter(item =>{
      return item.domain == host;
  })

  let domain = ""

  if(dom != ""){
    domain = dom[0].is_unsub;

    if(dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id)
  }else{
    domain = '0'
  }
  
  commit("setUnsubButton", domain);
},
};

const mutations = {
  setLanguage: (state, response)=> (state.language = response),
  setButton: (state, response) => (state.langButton = response),
  setTranslateCode: (state, response) => (state.translateCode = response),
  setSecondLang: (state, response) => (state.secondLang = response),
  setAuth: (state, response) => (state.auth_mobis = response),
  setUserProfile: (state, response) => (
    state.subscription_date_mobis = response.subscription_date,
    state.msisdn_mobis = response.msisdn,
    state.country_name_mobis = response.country_code,
    state.gateway_mobis = response.gateway_code
   ),
   setUnsubButton: (state, response) => (
    state.is_unsub = response)
};

export default {
  state,
  getters,
  actions,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/mobiscope-store.js